import { useQuery } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { PriceInsightOrdersListItem } from "../../insights.types";
import { requestPriceInsightOrders } from "./priceInsightOrders.request";

const usePriceInsightOrders = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<PriceInsightOrdersListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["order", "with-price-insights", requestParams],
    queryFn: async () => await requestPriceInsightOrders(requestParams),
    enabled: !!requestParams.productVariantId,
    ...options
  });

  return { priceInsightOrders: data?.data, meta: data?.meta, ...rest };
};

export default usePriceInsightOrders;
